module.exports = __webpack_public_path__ + "img/10859_L.3a603d14.png";